/*
 * Bildvorschau einmalig pro Konfiguration
 *
 * Zepto multipliziert Aufpreis-Produkte immer mit der Stückzahl. Für die Bildvorschau
 * soll aber nur 1x pro Motiv berechnet werden. Deshalb ist "Bildvorschau" in Zepto ein
 * Feld OHNE Aufpreis-Produkt, und dieses Skript hält das Produkt "Bildvorschau +1,99€"
 * im Warenkorb auf genau der Anzahl Positionen (Motive), die "Bildvorschau: Ja" haben.
 *
 * Die von diesem Skript verwaltete Bildvorschau-Position trägt keine Zepto-Eigenschaft
 * (_pc_pricing_ref), damit Zepto ihre Menge nicht an die Stückzahl angleicht.
 */
(function () {
  var BV_VARIANT_ID = 55328704692610;
  // Name oder Wert der Zepto-Option (Eigenschaft am Tortenaufleger), z.B. "mit Vorschau +1,99€"
  var OPTION_KEY = /vorschau/i;
  // Werte, die "keine Bildvorschau" bedeuten
  var NO_VALUE = /^\s*(nein|ohne.*|keine?.*|no|none|-)?\s*$/i;
  var CART_URL_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var originalFetch = window.fetch.bind(window);
  var inflight = null;
  var pending = false;
  var timer = null;
  var checkingOut = false;

  function wantsPreview(item) {
    if (item.variant_id === BV_VARIANT_ID || !item.properties) return false;
    var props = item.properties;
    // Wird die Bildvorschau für diese Position noch von Zepto berechnet, nicht doppelt zählen
    var split = props._pc_pricing_qty_split;
    if (split && String(split).indexOf(String(BV_VARIANT_ID)) !== -1) return false;
    for (var key in props) {
      if (!Object.prototype.hasOwnProperty.call(props, key)) continue;
      if (key.charAt(0) === '_') continue;
      var value = String(props[key]);
      // Option heißt "Bildvorschau" oder ihr Wert nennt die Bildvorschau (z.B. "mit Vorschau")
      if (!OPTION_KEY.test(key) && !OPTION_KEY.test(value)) continue;
      if (!NO_VALUE.test(value)) return true;
    }
    return false;
  }

  function isManagedPreview(item) {
    return item.variant_id === BV_VARIANT_ID && !(item.properties && item.properties._pc_pricing_ref);
  }

  function post(url, body) {
    return originalFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function refreshUi() {
    if (checkingOut) return;
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      // Schutz gegen Reload-Schleifen
      var key = 'bv_sync_reloads';
      var log = [];
      try {
        log = JSON.parse(sessionStorage.getItem(key) || '[]');
      } catch (e) {}
      var now = Date.now();
      log = log.filter(function (t) {
        return now - t < 10000;
      });
      if (log.length >= 3) return;
      log.push(now);
      try {
        sessionStorage.setItem(key, JSON.stringify(log));
      } catch (e) {}
      window.location.reload();
      return;
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    originalFetch('/?sections=cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var inner = html.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      })
      .catch(function () {});
  }

  function runSync() {
    return originalFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var desired = 0;
        var managed = [];
        cart.items.forEach(function (item) {
          if (wantsPreview(item)) desired += 1;
          else if (isManagedPreview(item)) managed.push(item);
        });

        var ops = [];
        if (managed.length === 0) {
          if (desired > 0) {
            ops.push(function () {
              return post('/cart/add.js', { items: [{ id: BV_VARIANT_ID, quantity: desired }] });
            });
          }
        } else {
          managed.forEach(function (item, i) {
            var qty = i === 0 ? desired : 0;
            if (item.quantity !== qty) {
              ops.push(function () {
                return post('/cart/change.js', { id: item.key, quantity: qty });
              });
            }
          });
        }
        return ops.reduce(function (chain, op) {
          return chain.then(op);
        }, Promise.resolve()).then(function () {
          return ops.length > 0;
        });
      })
      .then(function (changed) {
        if (changed) refreshUi();
      })
      .catch(function (err) {
        console.warn('[Bildvorschau] Sync fehlgeschlagen', err);
      });
  }

  // Gibt immer ein Promise zurück, das erst nach dem letzten nötigen Durchlauf erfüllt ist
  function sync() {
    if (inflight) {
      pending = true;
      return inflight;
    }
    inflight = runSync().then(function () {
      inflight = null;
      if (pending) {
        pending = false;
        return sync();
      }
    });
    return inflight;
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  // Warenkorb-Änderungen per fetch (Dawn) erkennen
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var result = originalFetch(input, init);
    if (url && CART_URL_RE.test(url)) {
      result.then(scheduleSync, scheduleSync);
    }
    return result;
  };

  // Warenkorb-Änderungen per XMLHttpRequest (Zepto/jQuery) erkennen
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && CART_URL_RE.test(String(url))) {
      this.addEventListener('loadend', scheduleSync);
    }
    return originalOpen.apply(this, arguments);
  };

  // Vor dem Checkout sicherstellen, dass die Bildvorschau stimmt
  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      clearTimeout(timer);
      checkingOut = true;
      sync().then(function () {
        window.location.href = '/checkout';
      });
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
